import { createContext } from "react";

export interface FormControlContextValue {
  id: string;
  hasError?: boolean;
  isValid?: boolean;
}

export const FormControlContext = createContext<FormControlContextValue | null>(
  null,
);
